export const contentKeys = {
  all: ['content'] as const,
  plans: () => [...contentKeys.all, 'plans'] as const,
  plansByFamily: (familyId: string) => [...contentKeys.plans(), familyId] as const,
  plan: (planId: string) => [...contentKeys.all, 'plan', planId] as const,
  storySelect: () => [...contentKeys.all, 'storySelect'] as const,
  storiesExist: () => [...contentKeys.all, 'storiesExist'] as const,
} as const;
